import { Button } from "@digdir/designsystemet-react";
import { ChevronLeftIcon } from "@navikt/aksel-icons";
import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

export const BekreftelseToForside = () => {
  const { t } = useTranslation();
  return (
    <div className="w-fit">
      <Button variant="secondary" asChild>
        <Link to="/">
          <ChevronLeftIcon />
          {t("pages.bekreftelse.actions.knapp-navigasjon")}
        </Link>
      </Button>
    </div>
  );
};
